var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { rootShouldForwardProp, styled } from '../styled';
export var labelComponentName = 'QuantumLabel';
export var Label = styled('span', {
    name: labelComponentName,
    slot: 'Root',
    shouldForwardProp: function (prop) { return rootShouldForwardProp(prop) && prop !== 'color' && prop !== 'variant'; },
})(function (_a) {
    var theme = _a.theme, _b = _a.color, color = _b === void 0 ? 'default' : _b, _c = _a.variant, variant = _c === void 0 ? 'default' : _c;
    return (__assign(__assign(__assign(__assign(__assign({}, theme.typography.overline), { padding: theme.spacing(0.25, 0.75), borderRadius: 4, display: 'inline-block', verticalAlign: 'middle' }), (variant === 'default' && __assign(__assign(__assign(__assign(__assign(__assign({}, (color === 'default' && {
        background: theme.tokens.color_bg_state_neutral_subtle,
        color: theme.tokens.color_fg_on_state_neutral_subtle,
    })), (color === 'primary' && {
        background: theme.tokens.color_bg_brand_primary_subtle,
        color: theme.tokens.color_fg_on_brand_primary_subtle,
    })), (color === 'info' && {
        background: theme.tokens.color_bg_state_info_subtle,
        color: theme.tokens.color_fg_on_state_info_subtle,
    })), (color === 'warning' && {
        background: theme.tokens.color_bg_state_caution_subtle,
        color: theme.tokens.color_fg_on_state_caution_subtle,
    })), (color === 'success' && {
        background: theme.tokens.color_bg_state_success_subtle,
        color: theme.tokens.color_fg_on_state_success_subtle,
    })), (color === 'danger' && {
        background: theme.tokens.color_bg_state_danger_subtle,
        color: theme.tokens.color_fg_on_state_danger_subtle,
    })))), (variant === 'outlined' && __assign(__assign(__assign(__assign(__assign({ backgroundColor: 'transparent', color: theme.tokens.color_fg_state_neutral, boxShadow: theme.mixins.borderAsBoxShadow(theme.tokens.color_border_state_neutral) }, (color === 'primary' && {
        boxShadow: theme.mixins.borderAsBoxShadow(theme.tokens.color_border_brand_primary),
        color: theme.tokens.color_fg_brand_primary,
    })), (color === 'info' && {
        boxShadow: theme.mixins.borderAsBoxShadow(theme.tokens.color_border_state_info),
        color: theme.tokens.color_fg_state_info,
    })), (color === 'warning' && {
        boxShadow: theme.mixins.borderAsBoxShadow(theme.tokens.color_border_state_caution),
        color: theme.tokens.color_fg_state_caution,
    })), (color === 'success' && {
        boxShadow: theme.mixins.borderAsBoxShadow(theme.tokens.color_border_state_success),
        color: theme.tokens.color_fg_state_success,
    })), (color === 'danger' && {
        boxShadow: theme.mixins.borderAsBoxShadow(theme.tokens.color_border_state_danger),
        color: theme.tokens.color_fg_state_danger,
    })))), (variant === 'filled' && __assign(__assign(__assign(__assign(__assign({ backgroundColor: theme.tokens.color_bg_state_neutral, color: theme.tokens.color_fg_on_state_neutral }, (color === 'primary' && {
        backgroundColor: theme.tokens.color_bg_brand_primary,
        color: theme.tokens.color_fg_on_brand_primary,
    })), (color === 'info' && {
        backgroundColor: theme.tokens.color_bg_state_info,
        color: theme.tokens.color_fg_on_state_info,
    })), (color === 'warning' && {
        backgroundColor: theme.tokens.color_bg_state_caution,
        color: theme.tokens.color_fg_on_state_caution,
    })), (color === 'success' && {
        backgroundColor: theme.tokens.color_bg_state_success,
        color: theme.tokens.color_fg_on_state_success,
    })), (color === 'danger' && {
        backgroundColor: theme.tokens.color_bg_state_danger,
        color: theme.tokens.color_fg_on_state_danger,
    })))));
});
